/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}




/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * simpleParallax.min - simpleParallax is a simple JavaScript library that gives your website parallax animations on any images, 
 * @date: 07-12-2019 18:53:52, 
 * @version: 5.2.0,
 * @link: https://simpleparallax.com/
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("simpleParallax",[],e):"object"==typeof exports?exports.simpleParallax=e():t.simpleParallax=e()}(window,function(){return(n={},s.m=i=[function(t,e,i){"use strict";function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}i.r(e);var s=new(function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.positions={top:0,bottom:0,height:0}}return function(t,e,i){e&&n(t.prototype,e),i&&n(t,i)}(t,[{key:"setViewportTop",value:function(t){return this.positions.top=t?t.scrollTop:window.pageYOffset,this.positions}},{key:"setViewportBottom",value:function(){return this.positions.bottom=this.positions.top+this.positions.height,this.positions}},{key:"setViewportAll",value:function(t){return this.positions.top=t?t.scrollTop:window.pageYOffset,this.positions.height=t?t.clientHeight:document.documentElement.clientHeight,this.positions.bottom=this.positions.top+this.positions.height,this.positions}}]),t}()),o=function(t){return NodeList.prototype.isPrototypeOf(t)||HTMLCollection.prototype.isPrototypeOf(t)?Array.from(t):"string"==typeof t||t instanceof String?document.querySelectorAll(t):[t]},r=function(){for(var t,e="transform webkitTransform mozTransform oTransform msTransform".split(" "),i=0;void 0===t;)t=void 0!==document.createElement("div").style[e[i]]?e[i]:void 0,i+=1;return t}(),a=function(t){return!!t&&(!!t.complete&&(void 0===t.naturalWidth||0!==t.naturalWidth))};function l(t){return function(t){if(Array.isArray(t)){for(var e=0,i=new Array(t.length);e<t.length;e++)i[e]=t[e];return i}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function u(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var h=function(){function i(t,e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),this.element=t,this.elementContainer=t,this.settings=e,this.isVisible=!0,this.isInit=!1,this.oldTranslateValue=-1,this.init=this.init.bind(this),a(t)?this.init():this.element.addEventListener("load",this.init)}return function(t,e,i){e&&u(t.prototype,e),i&&u(t,i)}(i,[{key:"init",value:function(){var t=this;this.isInit||this.element.closest(".simpleParallax")||(!1===this.settings.overflow&&this.wrapElement(this.element),this.setTransformCSS(),this.getElementOffset(),this.intersectionObserver(),this.getTranslateValue(),this.animate(),0<this.settings.delay&&setTimeout(function(){t.setTransitionCSS()},10),this.isInit=!0)}},{key:"wrapElement",value:function(){var t=this.element.closest("picture")||this.element,e=document.createElement("div");e.classList.add("simpleParallax"),e.style.overflow="hidden",t.parentNode.insertBefore(e,t),e.appendChild(t),this.elementContainer=e}},{key:"unWrapElement",value:function(){var t=this.elementContainer;t.replaceWith.apply(t,l(t.childNodes))}},{key:"setTransformCSS",value:function(){!1===this.settings.overflow&&(this.element.style[r]="scale(".concat(this.settings.scale,")")),this.element.style.willChange="transform"}},{key:"setTransitionCSS",value:function(){this.element.style.transition="transform ".concat(this.settings.delay,"s ").concat(this.settings.transition)}},{key:"unSetStyle",value:function(){this.element.style.willChange="",this.element.style[r]="",this.element.style.transition=""}},{key:"getElementOffset",value:function(){var t=this.elementContainer.getBoundingClientRect();if(this.elementHeight=t.height,this.elementTop=t.top+s.positions.top,this.settings.customContainer){var e=this.settings.customContainer.getBoundingClientRect();this.elementTop=t.top-e.top+s.positions.top}this.elementBottom=this.elementHeight+this.elementTop}},{key:"buildThresholdList",value:function(){for(var t=[],e=1;e<=this.elementHeight;e++){var i=e/this.elementHeight;t.push(i)}return t}},{key:"intersectionObserver",value:function(){var t={root:null,threshold:this.buildThresholdList()};this.observer=new IntersectionObserver(this.intersectionObserverCallback.bind(this),t),this.observer.observe(this.element)}},{key:"intersectionObserverCallback",value:function(t){for(var e=t.length-1;0<=e;e--)t[e].isIntersecting?this.isVisible=!0:this.isVisible=!1}},{key:"checkIfVisible",value:function(){return this.elementBottom>s.positions.top&&this.elementTop<s.positions.bottom}},{key:"getRangeMax",value:function(){var t=this.element.clientHeight;this.rangeMax=t*this.settings.scale-t}},{key:"getTranslateValue",value:function(){var t=((s.positions.bottom-this.elementTop)/((s.positions.height+this.elementHeight)/100)).toFixed(1);return t=Math.min(100,Math.max(0,t)),this.oldPercentage!==t&&(this.rangeMax||this.getRangeMax(),this.translateValue=(t/100*this.rangeMax-this.rangeMax/2).toFixed(0),this.oldTranslateValue!==this.translateValue&&(this.oldPercentage=t,this.oldTranslateValue=this.translateValue,!0))}},{key:"animate",value:function(){var t,e=0,i=0;(this.settings.orientation.includes("left")||this.settings.orientation.includes("right"))&&(i="".concat(this.settings.orientation.includes("left")?-1*this.translateValue:this.translateValue,"px")),(this.settings.orientation.includes("up")||this.settings.orientation.includes("down"))&&(e="".concat(this.settings.orientation.includes("up")?-1*this.translateValue:this.translateValue,"px")),t=!1===this.settings.overflow?"translate3d(".concat(i,", ").concat(e,", 0) scale(").concat(this.settings.scale,")"):"translate3d(".concat(i,", ").concat(e,", 0)"),this.element.style[r]=t}}]),i}();function c(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}i.d(e,"default",function(){return y});var f,m,p,d=!0,g=!1,v=[],y=function(){function i(t,e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),t&&(this.elements=o(t),this.defaults={delay:.4,orientation:"up",scale:1.3,overflow:!1,transition:"cubic-bezier(0,0,0,1)",customContainer:!1},this.settings=Object.assign(this.defaults,e),"IntersectionObserver"in window||(d=!1),this.settings.customContainer&&(console.log(o(this.settings.customContainer)[0]),this.customContainer=o(this.settings.customContainer)[0]),this.lastPosition=-1,this.resizeIsDone=this.resizeIsDone.bind(this),this.handleResize=this.handleResize.bind(this),this.proceedRequestAnimationFrame=this.proceedRequestAnimationFrame.bind(this),this.init())}return function(t,e,i){e&&c(t.prototype,e),i&&c(t,i)}(i,[{key:"init",value:function(){s.setViewportAll(this.customContainer);for(var t=this.elements.length-1;0<=t;t--){var e=new h(this.elements[t],this.settings);v.push(e)}f=v.length,g||(this.proceedRequestAnimationFrame(),window.addEventListener("resize",this.resizeIsDone),g=!0)}},{key:"resizeIsDone",value:function(){clearTimeout(p),p=setTimeout(this.handleResize,500)}},{key:"handleResize",value:function(){s.setViewportAll(this.customContainer);for(var t=f-1;0<=t;t--)v[t].getElementOffset(),v[t].getRangeMax();this.lastPosition=-1}},{key:"proceedRequestAnimationFrame",value:function(){if(s.setViewportTop(this.customContainer),this.lastPosition!==s.positions.top){s.setViewportBottom();for(var t=f-1;0<=t;t--)this.proceedElement(v[t]);m=window.requestAnimationFrame(this.proceedRequestAnimationFrame),this.lastPosition=s.positions.top}else m=window.requestAnimationFrame(this.proceedRequestAnimationFrame)}},{key:"proceedElement",value:function(t){(!d||this.customContainer?t.checkIfVisible():t.isVisible)&&t.getTranslateValue()&&t.animate()}},{key:"destroy",value:function(){var e=this,i=[];v=v.filter(function(t){return e.elements.includes(t.element)?(i.push(t),!1):t});for(var t=i.length-1;0<=t;t--)i[t].unSetStyle(),!1===this.settings.overflow&&i[t].unWrapElement();(f=v.length)||(window.cancelAnimationFrame(m),window.removeEventListener("resize",this.handleResize))}}]),i}()}],s.c=n,s.d=function(t,e,i){s.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},s.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},s.t=function(e,t){if(1&t&&(e=s(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(s.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)s.d(i,n,function(t){return e[t]}.bind(null,n));return i},s.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return s.d(e,"a",e),e},s.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},s.p="",s(s.s=0)).default;function s(t){if(n[t])return n[t].exports;var e=n[t]={i:t,l:!1,exports:{}};return i[t].call(e.exports,e,e.exports,s),e.l=!0,e.exports}var i,n});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(16);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(4);

__webpack_require__(5);

__webpack_require__(7);

__webpack_require__(8);

__webpack_require__(9);

__webpack_require__(10);

__webpack_require__(11);

__webpack_require__(12);

__webpack_require__(14);

__webpack_require__(15);

console.log('SVG JS Loaded');

// Slick
// Default WordPress JS

// SVG

console.log('Slick Loaded');

// Vendors


// Custom


console.log('Main JS Loaded');

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* http://keith-wood.name/svg.html
   SVG for jQuery v1.5.0.
   Written by Keith Wood (kbwood{at}iinet.com.au) August 2007.
   Available under the MIT (http://keith-wood.name/licence.html) license. 
   Please attribute the author if you use it. */

(function ($) {
	// Hide scope, no $ conflict

	/** The SVG manager.
 	<p>Use the singleton instance of this class, $.svg, 
 	to interact with the SVG functionality.</p>
 	<p>Expects HTML like:</p>
 	<pre>&lt;div>&lt;/div></pre>
 	@module SVGManager */
	function SVGManager() {
		this._settings = []; // Settings to be remembered per SVG object
		this._extensions = []; // List of SVG extensions added to SVGWrapper
		// for each entry [0] is extension name, [1] is extension class (function)
		// the function takes one parameter - the SVGWrapper instance
		this.regional = []; // Localisations, indexed by language, '' for default (English)
		this.regional[''] = { errorLoadingText: 'Error loading' };
		this.local = this.regional['']; // Current localisation
		this._uuid = new Date().getTime();
		this._ie = !!window.ActiveXObject;
	}

	$.extend(SVGManager.prototype, {
		/** Class name added to elements to indicate already configured with SVG. */
		markerClassName: 'hasSVG',
		/** Name of the data property for instance settings. */
		propertyName: 'svgwrapper',

		/** SVG namespace. */
		svgNS: 'http://www.w3.org/2000/svg',
		/** XLink namespace. */
		xlinkNS: 'http://www.w3.org/1999/xlink',

		/** SVG wrapper class. */
		_wrapperClass: SVGWrapper,

		/* Camel-case versions of attribute names containing dashes or are reserved words. */
		_attrNames: { class_: 'class', in_: 'in',
			alignmentBaseline: 'alignment-baseline', baselineShift: 'baseline-shift',
			clipPath: 'clip-path', clipRule: 'clip-rule',
			colorInterpolation: 'color-interpolation',
			colorInterpolationFilters: 'color-interpolation-filters',
			colorRendering: 'color-rendering', dominantBaseline: 'dominant-baseline',
			enableBackground: 'enable-background', fillOpacity: 'fill-opacity',
			fillRule: 'fill-rule', floodColor: 'flood-color',
			floodOpacity: 'flood-opacity', fontFamily: 'font-family',
			fontSize: 'font-size', fontSizeAdjust: 'font-size-adjust',
			fontStretch: 'font-stretch', fontStyle: 'font-style',
			fontVariant: 'font-variant', fontWeight: 'font-weight',
			glyphOrientationHorizontal: 'glyph-orientation-horizontal',
			glyphOrientationVertical: 'glyph-orientation-vertical',
			horizAdvX: 'horiz-adv-x', horizOriginX: 'horiz-origin-x',
			imageRendering: 'image-rendering', letterSpacing: 'letter-spacing',
			lightingColor: 'lighting-color', markerEnd: 'marker-end',
			markerMid: 'marker-mid', markerStart: 'marker-start',
			stopColor: 'stop-color', stopOpacity: 'stop-opacity',
			strikethroughPosition: 'strikethrough-position',
			strikethroughThickness: 'strikethrough-thickness',
			strokeDashArray: 'stroke-dasharray', strokeDashOffset: 'stroke-dashoffset',
			strokeLineCap: 'stroke-linecap', strokeLineJoin: 'stroke-linejoin',
			strokeMiterLimit: 'stroke-miterlimit', strokeOpacity: 'stroke-opacity',
			strokeWidth: 'stroke-width', textAnchor: 'text-anchor',
			textDecoration: 'text-decoration', textRendering: 'text-rendering',
			underlinePosition: 'underline-position', underlineThickness: 'underline-thickness',
			vertAdvY: 'vert-adv-y', vertOriginY: 'vert-origin-y',
			wordSpacing: 'word-spacing', writingMode: 'writing-mode' },

		/* Add the SVG object to its container. */
		_attachSVG: function _attachSVG(container, settings) {
			var svg = container.namespaceURI === this.svgNS ? container : null;
			var container = svg ? null : container;
			if ($(container || svg).hasClass(this.markerClassName)) {
				return;
			}
			if (typeof settings === 'string') {
				settings = { loadURL: settings };
			} else if (typeof settings === 'function') {
				settings = { onLoad: settings };
			}
			$(container || svg).addClass(this.markerClassName);
			try {
				if (!svg) {
					svg = document.createElementNS(this.svgNS, 'svg');
					svg.setAttribute('version', '1.1');
					if (container.clientWidth > 0) {
						svg.setAttribute('width', container.clientWidth);
					}
					if (container.clientHeight > 0) {
						svg.setAttribute('height', container.clientHeight);
					}
					container.appendChild(svg);
				}
				this._afterLoad(container, svg, settings || {});
			} catch (e) {
				$(container).html('<p>SVG is not supported natively on this browser</p>');
			}
		},

		/* Post-processing once loaded. */
		_afterLoad: function _afterLoad(container, svg, settings) {
			var settings = settings || this._settings[container.id];
			this._settings[container ? container.id : ''] = null;
			var wrapper = new this._wrapperClass(svg, container);
			$.data(container || svg, $.svg.propertyName, wrapper);
			try {
				if (settings.loadURL) {
					// Load URL
					wrapper.load(settings.loadURL, settings);
				}
				if (settings.settings) {
					// Additional settings
					wrapper.configure(settings.settings);
				}
				if (settings.onLoad && !settings.loadURL) {
					// Onload callback
					settings.onLoad.apply(container || svg, [wrapper]);
				}
			} catch (e) {
				alert(e);
			}
		},

		/** Return the SVG wrapper created for a given container.
  	@param container {string|Element|jQuery} Selector for the container or
  			the container for the SVG object or jQuery collection where first entry is the container.
  	@return {SVGWrapper} The corresponding SVG wrapper element, or <code>null</code> if not attached. */
		_getSVG: function _getSVG(container) {
			return $(container).data(this.propertyName);
		},

		/** Remove the SVG functionality from a div.
  	@param container {Element} The container for the SVG object. */
		_destroySVG: function _destroySVG(container) {
			container = $(container);
			if (!container.hasClass(this.markerClassName)) {
				return;
			}
			container.removeClass(this.markerClassName).removeData(this.propertyName);
			if (container[0].namespaceURI !== this.svgNS) {
				container.empty();
			}
		},

		/** Extend the SVGWrapper object with an embedded class.
  	<p>The constructor function must take a single parameter that is
     a reference to the owning SVG root object. This allows the 
  	extension to access the basic SVG functionality.</p>
  	@param name {string} The name of the <code>SVGWrapper</code> attribute to access the new class.
  	@param extClass {function} The extension class constructor. */
		addExtension: function addExtension(name, extClass) {
			this._extensions.push([name, extClass]);
		},

		/** Does this node belong to SVG?
  	@param node {Element} The node to be tested.
  	@return {boolean} <code>true</code> if an SVG node, <code>false</code> if not. */
		isSVGElem: function isSVGElem(node) {
			return node.nodeType === 1 && node.namespaceURI === $.svg.svgNS;
		}
	});

	/** The main SVG interface, which encapsulates the SVG element.
 	<p>Obtain a reference from $().svg('get')</p>
 	@module SVGWrapper */
	function SVGWrapper(svg, container) {
		this._svg = svg; // The SVG root node
		this._container = container; // The containing div
		for (var i = 0; i < $.svg._extensions.length; i++) {
			var extension = $.svg._extensions[i];
			this[extension[0]] = new extension[1](this);
		}
	}

	$.extend(SVGWrapper.prototype, {

		/** Retrieve the width of the SVG object.
  	@return {number} The width of the SVG canvas. */
		width: function width() {
			return this._container ? this._container.clientWidth : this._svg.width;
		},

		/** Retrieve the height of the SVG object.
  	@return {number} The height of the SVG canvas. */
		height: function height() {
			return this._container ? this._container.clientHeight : this._svg.height;
		},

		/** Retrieve the root SVG element.
  	@return {SVGElement} The top-level SVG element. */
		root: function root() {
			return this._svg;
		},

		/** Configure a SVG node.
  	@param [node] {SVGElement} The node to configure, or the SVG root if not specified.
  	@param settings {object} Additional settings for the root.
  	@param [clear=false] {boolean} <code>true</code> to remove existing attributes first,
  			<code>false</code> to add to what is already there.
  	@return {SVGWrapper} This wrapper. */
		configure: function configure(node, settings, clear) {
			if (!node.nodeName) {
				clear = settings;
				settings = node;
				node = this._svg;
			}
			if (clear) {
				for (var i = node.attributes.length - 1; i >= 0; i--) {
					var attr = node.attributes.item(i);
					if (!(attr.nodeName === 'onload' || attr.nodeName === 'version' || attr.nodeName.substring(0, 5) === 'xmlns')) {
						node.attributes.removeNamedItem(attr.nodeName);
					}
				}
			}
			for (var attrName in settings) {
				node.setAttribute($.svg._attrNames[attrName] || attrName, settings[attrName]);
			}
			return this;
		},

		/** Locate a specific element in the SVG document.
  	@param id {string} The element's identifier.
  	@return {SVGElement} The element reference, or <code>null</code> if not found. */
		getElementById: function getElementById(id) {
			return this._svg.ownerDocument.getElementById(id);
		},

		/** Change the attributes for a SVG node.
  	@param element {SVGElement} The node to change.
  	@param settings {object} The new settings.
  	@return {SVGWrapper} This wrapper. */
		change: function change(element, settings) {
			if (element) {
				for (var name in settings) {
					if (settings[name] == null) {
						element.removeAttribute($.svg._attrNames[name] || name);
					} else {
						element.setAttribute($.svg._attrNames[name] || name, settings[name]);
					}
				}
			}
			return this;
		},

		/** Check for parent being absent and adjust arguments accordingly.
  	@private
  	@param values {string[]} The given parameters.
  	@param names {string[]} The names of the parameters in order.
  	@param optSettings {string[]} The names of optional parameters.
  	@return {object} An object representing the named parameters. */
		_args: function _args(values, names, optSettings) {
			names.splice(0, 0, 'parent');
			names.splice(names.length, 0, 'settings');
			var args = {};
			var offset = 0;
			if (values[0] != null && values[0].jquery) {
				values[0] = values[0][0];
			}
			if (values[0] != null && !(_typeof(values[0]) === 'object' && values[0].nodeName)) {
				args['parent'] = null;
				offset = 1;
			}
			for (var i = 0; i < values.length; i++) {
				args[names[i + offset]] = values[i];
			}
			if (optSettings) {
				$.each(optSettings, function (i, value) {
					if (_typeof(args[value]) === 'object') {
						args.settings = args[value];
						args[value] = null;
					}
				});
			}
			return args;
		},

		/** Add a title.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param text {string} The text of the title.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new title node. */
		title: function title(parent, text, settings) {
			var args = this._args(arguments, ['text']);
			var node = this._makeNode(args.parent, 'title', args.settings || {});
			node.appendChild(this._svg.ownerDocument.createTextNode(args.text));
			return node;
		},

		/** Add a description.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param text {string} The text of the description.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new description node. */
		describe: function describe(parent, text, settings) {
			var args = this._args(arguments, ['text']);
			var node = this._makeNode(args.parent, 'desc', args.settings || {});
			node.appendChild(this._svg.ownerDocument.createTextNode(args.text));
			return node;
		},

		/** Add a definitions node.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param [id] {string} The ID of this definitions (optional).
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new definitions node. */
		defs: function defs(parent, id, settings) {
			var args = this._args(arguments, ['id'], ['id']);
			return this._makeNode(args.parent, 'defs', $.extend(args.id ? { id: args.id } : {}, args.settings || {}));
		},

		/** Add a symbol definition.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID of this symbol.
  	@param x1 {number} The left coordinate for this symbol.
  	@param y1 {number} The top coordinate for this symbol.
  	@param width {number} The width of this symbol.
  	@param height {number} The height of this symbol.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new symbol node. */
		symbol: function symbol(parent, id, x1, y1, width, height, settings) {
			var args = this._args(arguments, ['id', 'x1', 'y1', 'width', 'height']);
			return this._makeNode(args.parent, 'symbol', $.extend({ id: args.id,
				viewBox: args.x1 + ' ' + args.y1 + ' ' + args.width + ' ' + args.height }, args.settings || {}));
		},

		/** Add a marker definition.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID of this marker.
  	@param refX {number} The x-coordinate for the reference point.
  	@param refY {number} The y-coordinate for the reference point.
  	@param mWidth {number} The marker viewport width.
  	@param mHeight {number} The marker viewport height.
  	@param [orient] {string|number} 'auto' or angle (degrees).
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new marker node. */
		marker: function marker(parent, id, refX, refY, mWidth, mHeight, orient, settings) {
			var args = this._args(arguments, ['id', 'refX', 'refY', 'mWidth', 'mHeight', 'orient'], ['orient']);
			return this._makeNode(args.parent, 'marker', $.extend({ id: args.id, refX: args.refX, refY: args.refY, markerWidth: args.mWidth,
				markerHeight: args.mHeight, orient: args.orient || 'auto' }, args.settings || {}));
		},

		/** Add a style node.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param styles {string} The CSS styles.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new style node. */
		style: function style(parent, styles, settings) {
			var args = this._args(arguments, ['styles']);
			var node = this._makeNode(args.parent, 'style', $.extend({ type: 'text/css' }, args.settings || {}));
			node.appendChild(this._svg.ownerDocument.createTextNode(args.styles));
			return node;
		},

		/** Add a script node.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param script {string} The JavaScript code.
  	@param [type='text/javascript'] {string} The MIME type for the code.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new script node. */
		script: function script(parent, _script, type, settings) {
			var args = this._args(arguments, ['script', 'type'], ['type']);
			var node = this._makeNode(args.parent, 'script', $.extend({ type: args.type || 'text/javascript' }, args.settings || {}));
			node.appendChild(this._svg.ownerDocument.createTextNode(args.script));
			if ($.svg._ie) {
				$.globalEval(args.script);
			}
			return node;
		},

		/** Add a linear gradient definition.
  	<p>Specify all of <code>x1</code>, <code>y1</code>, <code>x2</code>, <code>y2</code> or none of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID for this gradient.
  	@param stops {string[][]} The gradient stops, each entry is [0] is offset (0.0-1.0 or 0%-100%),
  			[1] is colour, [2] is opacity (optional).
  	@param [x1] {number} The x-coordinate of the gradient start.
  	@param [y1] {number} The y-coordinate of the gradient start.
  	@param [x2] {number} The x-coordinate of the gradient end.
  	@param [y2] {number} The y-coordinate of the gradient end.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new linear gradient node. */
		linearGradient: function linearGradient(parent, id, stops, x1, y1, x2, y2, settings) {
			var args = this._args(arguments, ['id', 'stops', 'x1', 'y1', 'x2', 'y2'], ['x1']);
			var sets = $.extend({ id: args.id }, args.x1 != null ? { x1: args.x1, y1: args.y1, x2: args.x2, y2: args.y2 } : {});
			return this._gradient(args.parent, 'linearGradient', $.extend(sets, args.settings || {}), args.stops);
		},

		/** Add a radial gradient definition.
  	<p>Specify all of <code>cx</code>, <code>cy</code>, <code>r</code>,
  	<code>fx</code>, <code>fy</code> or none of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID for this gradient.
  	@param stops {string[][]} The gradient stops, each entry [0] is offset (0.0-1.0 or 0%-100%),
  			[1] is colour, [2] is opacity (optional).
  	@param [cx] {number} The x-coordinate of the largest circle centre.
  	@param [cy] {number} The y-coordinate of the largest circle centre.
  	@param [r] {number} The radius of the largest circle.
  	@param [fx] {number} The x-coordinate of the gradient focus.
  	@param [fy] {number} The y-coordinate of the gradient focus.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new radial gradient node. */
		radialGradient: function radialGradient(parent, id, stops, cx, cy, r, fx, fy, settings) {
			var args = this._args(arguments, ['id', 'stops', 'cx', 'cy', 'r', 'fx', 'fy'], ['cx']);
			var sets = $.extend({ id: args.id }, args.cx != null ? { cx: args.cx, cy: args.cy, r: args.r, fx: args.fx, fy: args.fy } : {});
			return this._gradient(args.parent, 'radialGradient', $.extend(sets, args.settings || {}), args.stops);
		},

		/** Add a gradient node.
  	@private
  	@param parent {SVGElement|jQuery} The parent node for the new node.
  	@param name {string} The type of gradient node to create.
  	@param settings {object} The settings for this node.
  	@param stops {string[][]} The gradient stops.
  	@return {SVGElement} The new gradient node. */
		_gradient: function _gradient(parent, name, settings, stops) {
			var node = this._makeNode(parent, name, settings);
			for (var i = 0; i < stops.length; i++) {
				var stop = stops[i];
				this._makeNode(node, 'stop', $.extend({ offset: stop[0], stopColor: stop[1] }, stop[2] != null ? { stopOpacity: stop[2] } : {}));
			}
			return node;
		},

		/** Add a pattern definition.
  	<p>Specify all of <code>vx</code>, <code>vy</code>, <code>xwidth</code>,
  	<code>vheight</code> or none of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID for this pattern.
  	@param x {number} The x-coordinate for the left edge of the pattern.
  	@param y {number} The y-coordinate for the top edge of the pattern.
  	@param width {number} The width of the pattern.
  	@param height {number} The height of the pattern.
  	@param [vx] {number} The minimum x-coordinate for view box.
  	@param [vy] {number} The minimum y-coordinate for the view box.
  	@param [vwidth] {number} The width of the view box.
  	@param [vheight] {number} The height of the view box.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new pattern definition node. */
		pattern: function pattern(parent, id, x, y, width, height, vx, vy, vwidth, vheight, settings) {
			var args = this._args(arguments, ['id', 'x', 'y', 'width', 'height', 'vx', 'vy', 'vwidth', 'vheight'], ['vx']);
			var sets = $.extend({ id: args.id, x: args.x, y: args.y, width: args.width, height: args.height }, args.vx != null ? { viewBox: args.vx + ' ' + args.vy + ' ' + args.vwidth + ' ' + args.vheight } : {});
			return this._makeNode(args.parent, 'pattern', $.extend(sets, args.settings || {}));
		},

		/** Add a clip path definition.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID for this path.
  	@param [units='userSpaceOnUse'] {string} Either 'userSpaceOnUse' or 'objectBoundingBox'.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new clip path definition node. */
		clipPath: function clipPath(parent, id, units, settings) {
			var args = this._args(arguments, ['id', 'units']);
			args.units = args.units || 'userSpaceOnUse';
			return this._makeNode(args.parent, 'clipPath', $.extend({ id: args.id, clipPathUnits: args.units }, args.settings || {}));
		},

		/** Add a mask definition.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param id {string} The ID for this mask.
  	@param x {number} The x-coordinate for the left edge of the mask.
  	@param y {number} The y-coordinate for the top edge of the mask.
  	@param width {number} The width of the mask.
  	@param height {number} The height of the mask.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new mask definition node. */
		mask: function mask(parent, id, x, y, width, height, settings) {
			var args = this._args(arguments, ['id', 'x', 'y', 'width', 'height']);
			return this._makeNode(args.parent, 'mask', $.extend({ id: args.id, x: args.x, y: args.y, width: args.width, height: args.height }, args.settings || {}));
		},

		/** Create a new path object.
  	@return {SVGPath} A new path object. */
		createPath: function createPath() {
			return new SVGPath();
		},

		/** Create a new text object.
  	@return {SVGText} A new text object. */
		createText: function createText() {
			return new SVGText();
		},

		/** Add an embedded SVG element.
  	<p>Specify all of <code>vx</code>, <code>vy</code>,
  	<code>vwidth</code>, <code>vheight</code> or none of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param x {number} The x-coordinate for the left edge of the node.
  	@param y {number} The y-coordinate for the top edge of the node.
  	@param width {number} The width of the node.
  	@param height {number} The height of the node.
  	@param [vx] {number} The minimum x-coordinate for view box.
  	@param [vy] {number} The minimum y-coordinate for the view box.
  	@param [vwidth] {number} The width of the view box.
  	@param [vheight] {number} The height of the view box.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new svg node. */
		svg: function svg(parent, x, y, width, height, vx, vy, vwidth, vheight, settings) {
			var args = this._args(arguments, ['x', 'y', 'width', 'height', 'vx', 'vy', 'vwidth', 'vheight'], ['vx']);
			var sets = $.extend({ x: args.x, y: args.y, width: args.width, height: args.height }, args.vx != null ? { viewBox: args.vx + ' ' + args.vy + ' ' + args.vwidth + ' ' + args.vheight } : {});
			return this._makeNode(args.parent, 'svg', $.extend(sets, args.settings || {}));
		},

		/** Create a group.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param [id] {string} The ID of this group.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new group node. */
		group: function group(parent, id, settings) {
			var args = this._args(arguments, ['id'], ['id']);
			return this._makeNode(args.parent, 'g', $.extend({ id: args.id }, args.settings || {}));
		},

		/** Add a usage reference.
  	<p>Specify all of <code>x</code>, <code>y</code>, <code>width</code>, <code>height</code> or none of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param [x] {number} The x-coordinate for the left edge of the node.
  	@param [y] {number} The y-coordinate for the top edge of the node.
  	@param [width] {number} The width of the node.
  	@param [height] {number} The height of the node.
  	@param ref {string} The ID of the definition node.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new usage reference node. */
		use: function use(parent, x, y, width, height, ref, settings) {
			var args = this._args(arguments, ['x', 'y', 'width', 'height', 'ref']);
			if (typeof args.x === 'string') {
				args.ref = args.x;
				args.settings = args.y;
				args.x = args.y = args.width = args.height = null;
			}
			var node = this._makeNode(args.parent, 'use', $.extend({ x: args.x, y: args.y, width: args.width, height: args.height }, args.settings || {}));
			node.setAttributeNS($.svg.xlinkNS, 'href', args.ref);
			return node;
		},

		/** Add a link, which applies to all child elements.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param ref {string} The target URL.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new link node. */
		link: function link(parent, ref, settings) {
			var args = this._args(arguments, ['ref']);
			var node = this._makeNode(args.parent, 'a', args.settings);
			node.setAttributeNS($.svg.xlinkNS, 'href', args.ref);
			return node;
		},

		/** Add an image.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param x {number} The x-coordinate for the left edge of the image.
  	@param y {number} The y-coordinate for the top edge of the image.
  	@param width {number} The width of the image.
  	@param height {number} The height of the image.
  	@param ref {string} The path to the image.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new image node. */
		image: function image(parent, x, y, width, height, ref, settings) {
			var args = this._args(arguments, ['x', 'y', 'width', 'height', 'ref']);
			var node = this._makeNode(args.parent, 'image', $.extend({ x: args.x, y: args.y, width: args.width, height: args.height }, args.settings || {}));
			node.setAttributeNS($.svg.xlinkNS, 'href', args.ref);
			return node;
		},

		/** Draw a path.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param path {string|SVGPath} The path to draw.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new path node. */
		path: function path(parent, _path, settings) {
			var args = this._args(arguments, ['path']);
			return this._makeNode(args.parent, 'path', $.extend({ d: args.path.path ? args.path.path() : args.path }, args.settings || {}));
		},

		/** Draw a rectangle.
  	<p>Specify both of <code>rx</code> and <code>ry</code> or neither.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param x {number} The x-coordinate for the left edge of the rectangle.
  	@param y {number} The y-coordinate for the top edge of the rectangle.
  	@param width {number} The width of the rectangle.
  	@param height {number} The height of the rectangle.
  	@param [rx] {number} The x-radius of the ellipse for the rounded corners.
  	@param [ry] {number} The y-radius of the ellipse for the rounded corners.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new rectangle node. */
		rect: function rect(parent, x, y, width, height, rx, ry, settings) {
			var args = this._args(arguments, ['x', 'y', 'width', 'height', 'rx', 'ry'], ['rx']);
			return this._makeNode(args.parent, 'rect', $.extend({ x: args.x, y: args.y, width: args.width, height: args.height }, args.rx ? { rx: args.rx, ry: args.ry } : {}, args.settings || {}));
		},

		/** Draw a circle.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param cx {number} The x-coordinate for the centre of the circle.
  	@param cy {number} The y-coordinate for the centre of the circle.
  	@param r {number} The radius of the circle.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new circle node. */
		circle: function circle(parent, cx, cy, r, settings) {
			var args = this._args(arguments, ['cx', 'cy', 'r']);
			return this._makeNode(args.parent, 'circle', $.extend({ cx: args.cx, cy: args.cy, r: args.r }, args.settings || {}));
		},

		/** Draw an ellipse.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param cx {number} The x-coordinate for the centre of the ellipse.
  	@param cy {number} The y-coordinate for the centre of the ellipse.
  	@param rx {number} The x-radius of the ellipse.
  	@param ry {number} The y-radius of the ellipse.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new ellipse node. */
		ellipse: function ellipse(parent, cx, cy, rx, ry, settings) {
			var args = this._args(arguments, ['cx', 'cy', 'rx', 'ry']);
			return this._makeNode(args.parent, 'ellipse', $.extend({ cx: args.cx, cy: args.cy, rx: args.rx, ry: args.ry }, args.settings || {}));
		},

		/** Draw a line.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param x1 {number} The x-coordinate for the start of the line.
  	@param y1 {number} The y-coordinate for the start of the line.
  	@param x2 {number} The x-coordinate for the end of the line.
  	@param y2 {number} The y-coordinate for the end of the line.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new line node. */
		line: function line(parent, x1, y1, x2, y2, settings) {
			var args = this._args(arguments, ['x1', 'y1', 'x2', 'y2']);
			return this._makeNode(args.parent, 'line', $.extend({ x1: args.x1, y1: args.y1, x2: args.x2, y2: args.y2 }, args.settings || {}));
		},

		/** Draw a polygonal line.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param points {number[][]} The x-/y-coordinates for the points on the line.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new polygonal line node. */
		polyline: function polyline(parent, points, settings) {
			var args = this._args(arguments, ['points']);
			return this._poly(args.parent, 'polyline', args.points, args.settings);
		},

		/** Draw a polygonal shape.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param points {number[][]} The x-/y-coordinates for the points on the shape.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new polygonal shape node. */
		polygon: function polygon(parent, points, settings) {
			var args = this._args(arguments, ['points']);
			return this._poly(args.parent, 'polygon', args.points, args.settings);
		},

		/** Draw a polygonal line or shape.
  	@private
  	@param parent {SVGElement|jQuery} The parent node for the new node.
  	@param name {string} The type of polygon to create.
  	@param points {number[][]} The x-/y-coordinates for the points on the shape.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new polygon node. */
		_poly: function _poly(parent, name, points, settings) {
			var ps = '';
			for (var i = 0; i < points.length; i++) {
				ps += points[i].join() + ' ';
			}
			return this._makeNode(parent, name, $.extend({ points: $.trim(ps) }, settings || {}));
		},

		/** Draw text.
  	<p>Specify both of <code>x</code> and <code>y</code> or neither of them.</p>
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param [x] {number|number[]} The x-coordinate(s) for the text.
  	@param [y] {number|number[]} The y-coordinate(s) for the text.
  	@param value {string|SVGText} The text content or text with spans and references.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new text node. */
		text: function text(parent, x, y, value, settings) {
			var args = this._args(arguments, ['x', 'y', 'value']);
			if (typeof args.x === 'string' && arguments.length < 4) {
				args.value = args.x;
				args.settings = args.y;
				args.x = args.y = null;
			}
			return this._text(args.parent, 'text', args.value, $.extend({ x: args.x && $.isArray(args.x) ? args.x.join(' ') : args.x,
				y: args.y && $.isArray(args.y) ? args.y.join(' ') : args.y }, args.settings || {}));
		},

		/** Draw text along a path.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param path {string} The ID of the path.
  	@param value {string|SVGText} The text content or text with spans and references.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new textpath node. */
		textpath: function textpath(parent, path, value, settings) {
			var args = this._args(arguments, ['path', 'value']);
			var node = this._text(args.parent, 'textPath', args.value, args.settings || {});
			node.setAttributeNS($.svg.xlinkNS, 'href', args.path);
			return node;
		},

		/** Draw text.
  	@private
  	@param parent {SVGElement|jQuery} The parent node for the new node.
  	@param name {string} The type of text to create.
  	@param value {string|SVGText} The text content or text with spans and references.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new text node. */
		_text: function _text(parent, name, value, settings) {
			var node = this._makeNode(parent, name, settings);
			if (typeof value === 'string') {
				node.appendChild(node.ownerDocument.createTextNode(value));
			} else {
				for (var i = 0; i < value._parts.length; i++) {
					var part = value._parts[i];
					if (part[0] === 'tspan') {
						var child = this._makeNode(node, part[0], part[2]);
						child.appendChild(node.ownerDocument.createTextNode(part[1]));
						node.appendChild(child);
					} else if (part[0] === 'tref') {
						var child = this._makeNode(node, part[0], part[2]);
						child.setAttributeNS($.svg.xlinkNS, 'href', part[1]);
						node.appendChild(child);
					} else if (part[0] === 'textpath') {
						var set = $.extend({}, part[2]);
						set.href = null;
						var child = this._makeNode(node, part[0], set);
						child.setAttributeNS($.svg.xlinkNS, 'href', part[2].href);
						child.appendChild(node.ownerDocument.createTextNode(part[1]));
						node.appendChild(child);
					} else {
						// straight text
						node.appendChild(node.ownerDocument.createTextNode(part[1]));
					}
				}
			}
			return node;
		},

		/** Add a custom SVG element.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param name {string} The name of the element.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new custom node. */
		other: function other(parent, name, settings) {
			var args = this._args(arguments, ['name']);
			return this._makeNode(args.parent, args.name, args.settings || {});
		},

		/** Create a SVG node with the given settings.
  	@private
  	@param parent {SVGElement|jQuery} The parent node for the new node, or SVG root if <code>null</code>.
  	@param name {string} The name of the element.
  	@param [settings] {object} Additional settings for this node.
  	@return {SVGElement} The new node. */
		_makeNode: function _makeNode(parent, name, settings) {
			parent = parent || this._svg;
			var node = this._svg.ownerDocument.createElementNS($.svg.svgNS, name);
			for (var name in settings) {
				var value = settings[name];
				if (value != null && (typeof value !== 'string' || value !== '')) {
					node.setAttribute($.svg._attrNames[name] || name, value);
				}
			}
			parent.appendChild(node);
			return node;
		},

		/** Add an existing SVG node to the document.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param node {SVGElement|string|jQuery} The new node to add or
  			the jQuery selector for the node or the set of nodes to add.
  	@return {SVGWrapper} This wrapper. */
		add: function add(parent, node) {
			var args = this._args(arguments.length === 1 ? [null, parent] : arguments, ['node']);
			var svg = this;
			args.parent = args.parent || this._svg;
			args.node = args.node.jquery ? args.node : $(args.node);
			try {
				args.parent.appendChild(args.node.cloneNode(true));
			} catch (e) {
				args.node.each(function () {
					var child = svg._cloneAsSVG(this);
					if (child) {
						args.parent.appendChild(child);
					}
				});
			}
			return this;
		},

		/** Clone an existing SVG node and add it to the document.
  	@param [parent] {SVGElement|jQuery} The parent node for the new node, or SVG root if not specified.
  	@param node {SVGEelement|string|jQuery} The new node to add or
  			the jQuery selector for the node or the set of nodes to clone.
  	@return {SVGElement[]} The collection of new nodes. */
		clone: function clone(parent, node) {
			var svg = this;
			var args = this._args(arguments.length === 1 ? [null, parent] : arguments, ['node']);
			args.parent = args.parent || this._svg;
			args.node = args.node.jquery ? args.node : $(args.node);
			var newNodes = [];
			args.node.each(function () {
				var child = svg._cloneAsSVG(this);
				if (child) {
					child.id = '';
					args.parent.appendChild(child);
					newNodes.push(child);
				}
			});
			return newNodes;
		},

		/** SVG nodes must belong to the SVG namespace, so clone and ensure this is so.
  	@private
  	@param node {SVGElement} The SVG node to clone.
  	@return {SVGElement} The cloned node. */
		_cloneAsSVG: function _cloneAsSVG(node) {
			var newNode = null;
			if (node.nodeType === 1) {
				// element
				newNode = this._svg.ownerDocument.createElementNS($.svg.svgNS, this._checkName(node.nodeName));
				for (var i = 0; i < node.attributes.length; i++) {
					var attr = node.attributes.item(i);
					if (attr.nodeName !== 'xmlns' && attr.nodeValue) {
						if (attr.prefix === 'xlink') {
							newNode.setAttributeNS($.svg.xlinkNS, attr.localName || attr.baseName, attr.nodeValue);
						} else {
							newNode.setAttribute(this._checkName(attr.nodeName), attr.nodeValue);
						}
					}
				}
				for (var i = 0; i < node.childNodes.length; i++) {
					var child = this._cloneAsSVG(node.childNodes[i]);
					if (child) {
						newNode.appendChild(child);
					}
				}
			} else if (node.nodeType === 3) {
				// text
				if ($.trim(node.nodeValue)) {
					newNode = this._svg.ownerDocument.createTextNode(node.nodeValue);
				}
			} else if (node.nodeType === 4) {
				// CDATA
				if ($.trim(node.nodeValue)) {
					try {
						newNode = this._svg.ownerDocument.createCDATASection(node.nodeValue);
					} catch (e) {
						newNode = this._svg.ownerDocument.createTextNode(node.nodeValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
					}
				}
			}
			return newNode;
		},

		/** Node names must be lower case and without SVG namespace prefix.
  	@private
  	@param name {string} The name to check.
  	@return {string} The corrected name. */
		_checkName: function _checkName(name) {
			name = name.substring(0, 1) >= 'A' && name.substring(0, 1) <= 'Z' ? name.toLowerCase() : name;
			return name.substring(0, 4) === 'svg:' ? name.substring(4) : name;
		},

		/** Load an external SVG document.
  	@param url {string} The location of the SVG document or
  			the actual SVG content (starting with '<code>&lt;svg</code>'.
  	@param settings {boolean|function|object} Either <code>addTo</code> below or <code>onLoad</code> below or
  			additional settings for the load with attributes below:
  			<code>addTo</code> {boolean} <code>true</code> to add to what's already there,
  			or <code>false</code> to clear the canvas first,
  			<code>changeSize</code> {boolean} <code>true</code> to allow the canvas size to change,
  			or <code>false</code> to retain the original,
  			<code>onLoad</code> {function} callback after the document has loaded,
  			'<code>this</code>' is the container, receives SVG object and optional error message as a parameter,
  			<code>parent</code> {string|SVGElement|jQuery} the parent to load into,
  			defaults to top-level svg element.
  	@return {SVGWrapper} This wrapper. */
		load: function load(url, settings) {
			settings = typeof settings === 'boolean' ? { addTo: settings } : typeof settings === 'function' ? { onLoad: settings } : typeof settings === 'string' ? { parent: settings } : (typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) === 'object' && settings.nodeName ? { parent: settings } : (typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) === 'object' && settings.jquery ? { parent: settings } : settings || {};
			if (!settings.parent && !settings.addTo) {
				this.clear(false);
			}
			var size = [this._svg.getAttribute('width'), this._svg.getAttribute('height')];
			var wrapper = this;
			// Report a problem with the load
			var reportError = function reportError(message) {
				message = $.svg.local.errorLoadingText + ': ' + message;
				if (settings.onLoad) {
					settings.onLoad.apply(wrapper._container || wrapper._svg, [wrapper, message]);
				} else {
					wrapper.text(null, 10, 20, message);
				}
			};
			// Create a DOM from SVG content
			var loadXML4IE = function loadXML4IE(data) {
				var xml = new ActiveXObject('Microsoft.XMLDOM');
				xml.validateOnParse = false;
				xml.resolveExternals = false;
				xml.async = false;
				xml.loadXML(data);
				if (xml.parseError.errorCode !== 0) {
					reportError(xml.parseError.reason);
					return null;
				}
				return xml;
			};
			// Load the SVG DOM
			var loadSVG = function loadSVG(data) {
				if (!data) {
					return;
				}
				if (data.documentElement.nodeName !== 'svg') {
					var errors = data.getElementsByTagName('parsererror');
					var messages = errors.length ? errors[0].getElementsByTagName('div') : []; // Safari
					reportError(!errors.length ? '???' : (messages.length ? messages[0] : errors[0]).firstChild.nodeValue);
					return;
				}
				var parent = settings.parent ? $(settings.parent)[0] : wrapper._svg;
				var attrs = {};
				for (var i = 0; i < data.documentElement.attributes.length; i++) {
					var attr = data.documentElement.attributes.item(i);
					if (!(attr.nodeName === 'version' || attr.nodeName.substring(0, 5) === 'xmlns')) {
						attrs[attr.nodeName] = attr.nodeValue;
					}
				}
				wrapper.configure(parent, attrs, !settings.parent);
				var nodes = data.documentElement.childNodes;
				for (var i = 0; i < nodes.length; i++) {
					try {
						parent.appendChild(wrapper._svg.ownerDocument.importNode(nodes[i], true));
						if (nodes[i].nodeName === 'script') {
							$.globalEval(nodes[i].textContent);
						}
					} catch (e) {
						wrapper.add(parent, nodes[i]);
					}
				}
				if (!settings.keepRelativeLinks && url.match('/')) {
					var base = url.replace(/\/[^\/]*$/, '/');
					$('*', parent).each(function () {
						var href = $(this).attr('xlink:href');
						if (href && !href.match(/(^[a-z][-a-z0-9+.]*:.*$)|(^\/.*$)|(^#.*$)/i)) {
							$(this).attr('xlink:href', base + href);
						}
					});
				}
				if (!settings.changeSize) {
					wrapper.configure(parent, { width: size[0], height: size[1] });
				}
				if (settings.onLoad) {
					settings.onLoad.apply(wrapper._container || wrapper._svg, [wrapper]);
				}
			};
			if (url.match('<svg')) {
				// Inline SVG
				try {
					loadSVG(new DOMParser().parseFromString(url, 'text/xml'));
				} catch (e) {
					reportError(e);
				}
			} else {
				// Remote SVG
				$.ajax({ url: url, dataType: 'xml',
					success: function success(xml) {
						loadSVG(xml);
					}, error: function error(http, message, exc) {
						reportError(message + (exc ? ' ' + exc.message : ''));
					} });
			}
			return this;
		},

		/** Delete a specified node.
  	@param node {SVGElement|jQuery} The drawing node to remove.
  	@return {SVGWrapper} This wrapper. */
		remove: function remove(node) {
			node = node.jquery ? node[0] : node;
			node.parentNode.removeChild(node);
			return this;
		},

		/** Delete everything in the current document.
  	@param [attrsToo=false] {boolean} <code>true</code> to clear any root attributes as well,
  			<code>false</code> to leave them.
  	@return {SVGWrapper} This wrapper. */
		clear: function clear(attrsToo) {
			if (attrsToo) {
				this.configure({}, true);
			}
			while (this._svg.firstChild) {
				this._svg.removeChild(this._svg.firstChild);
			}
			return this;
		},

		/** Serialise the current diagram into an SVG text document.
  	@param [node] {SVGElement} The starting node, or SVG root if not specified .
  	@return {string} The SVG as text. */
		toSVG: function toSVG(node) {
			node = node || this._svg;
			return typeof XMLSerializer === 'undefined' ? this._toSVG(node) : new XMLSerializer().serializeToString(node);
		},

		/** Serialise one node in the SVG hierarchy.
  	@private
  	@param node {SVGElement} The current node to serialise.
  	@return {string} The serialised SVG. */
		_toSVG: function _toSVG(node) {
			var svgDoc = '';
			if (!node) {
				return svgDoc;
			}
			if (node.nodeType === 3) {
				// Text
				svgDoc = node.nodeValue;
			} else if (node.nodeType === 4) {
				// CDATA
				svgDoc = '<![CDATA[' + node.nodeValue + ']]>';
			} else {
				// Element
				svgDoc = '<' + node.nodeName;
				if (node.attributes) {
					for (var i = 0; i < node.attributes.length; i++) {
						var attr = node.attributes.item(i);
						if (!($.trim(attr.nodeValue) === '' || attr.nodeValue.match(/^\[object/) || attr.nodeValue.match(/^function/))) {
							svgDoc += ' ' + (attr.namespaceURI === $.svg.xlinkNS ? 'xlink:' : '') + attr.nodeName + '="' + attr.nodeValue + '"';
						}
					}
				}
				if (node.firstChild) {
					svgDoc += '>';
					var child = node.firstChild;
					while (child) {
						svgDoc += this._toSVG(child);
						child = child.nextSibling;
					}
					svgDoc += '</' + node.nodeName + '>';
				} else {
					svgDoc += '/>';
				}
			}
			return svgDoc;
		}
	});

	/** Helper to generate an SVG path.
 	<p>Obtain an instance from the SVGWrapper object.</p>
 	<p>String calls together to generate the path and use its value:</p>
 	@module SVGPath
 	@example var path = root.createPath();
    root.path(null, path.move(100, 100).line(300, 100).line(200, 300).close(), {fill: 'red'});
  // or
    root.path(null, path.move(100, 100).line([[300, 100], [200, 300]]).close(), {fill: 'red'}); */
	function SVGPath() {
		this._path = '';
	}

	$.extend(SVGPath.prototype, {
		/** Prepare to create a new path.
  	@return {SVGPath} This path. */
		reset: function reset() {
			this._path = '';
			return this;
		},

		/** Move the pointer to a position.
  	@param x {number|number[][]} x-coordinate to move to or x-/y-coordinates to move to.
  	@param [y] {number} y-coordinate to move to (omitted if <code>x</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		move: function move(x, y, relative) {
			relative = $.isArray(x) ? y : relative;
			return this._coords(relative ? 'm' : 'M', x, y);
		},

		/** Draw a line to a position.
  	@param x {number|number[][]} x-coordinate to move to or x-/y-coordinates to move to.
  	@param [y] {number} y-coordinate to move to (omitted if <code>x</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		line: function line(x, y, relative) {
			relative = $.isArray(x) ? y : relative;
			return this._coords(relative ? 'l' : 'L', x, y);
		},

		/** Draw a horizontal line to a position.
  	@param x {number|number[]} x-coordinate to draw to or x-coordinates to draw to.
  	@param relative {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		horiz: function horiz(x, relative) {
			this._path += (relative ? 'h' : 'H') + ($.isArray(x) ? x.join(' ') : x);
			return this;
		},

		/** Draw a vertical line to a position.
  	@param y {number|number[]} y-coordinate to draw to or y-coordinates to draw to.
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		vert: function vert(y, relative) {
			this._path += (relative ? 'v' : 'V') + ($.isArray(y) ? y.join(' ') : y);
			return this;
		},

		/** Draw a cubic Bézier curve.
  	@param x1 {number|number[][]} x-coordinate of beginning control point or
  			x-/y-coordinates of control and end points to draw to.
  	@param [y1] {number} y-coordinate of beginning control point (omitted if <code>x1</code> is array).
  	@param [x2] {number} x-coordinate of ending control point (omitted if <code>x1</code> is array).
  	@param [y2] {number} y-coordinate of ending control point (omitted if <code>x1</code> is array).
  	@param [x] {number} x-coordinate of curve end (omitted if <code>x1</code> is array).
  	@param [y] {number} y-coordinate of curve end (omitted if <code>x1</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		curveC: function curveC(x1, y1, x2, y2, x, y, relative) {
			relative = $.isArray(x1) ? y1 : relative;
			return this._coords(relative ? 'c' : 'C', x1, y1, x2, y2, x, y);
		},

		/** Continue a cubic Bézier curve.
  	<p>Starting control point is the reflection of the previous end control point.</p>
  	@param x2 {number|number[][]} x-coordinate of ending control point or
  			x-/y-coordinates of control and end points to draw to.
  	@param [y2] {number} y-coordinate of ending control point (omitted if <code>x2</code> is array).
  	@param [x] {number} x-coordinate of curve end (omitted if <code>x2</code> is array).
  	@param [y] {number} y-coordinate of curve end (omitted if <code>x2</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		smoothC: function smoothC(x2, y2, x, y, relative) {
			relative = $.isArray(x2) ? y2 : relative;
			return this._coords(relative ? 's' : 'S', x2, y2, x, y);
		},

		/** Draw a quadratic Bézier curve.
  	@param x1 {number|number[][]} x-coordinate of control point or
  			x-/y-coordinates of control and end points to draw to.
  	@param [y1] {number} y-coordinate of control point (omitted if <code>x1</code> is array).
  	@param [x] {number} x-coordinate of curve end (omitted if <code>x1</code> is array).
  	@param [y] {number} y-coordinate of curve end (omitted if <code>x1</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		curveQ: function curveQ(x1, y1, x, y, relative) {
			relative = $.isArray(x1) ? y1 : relative;
			return this._coords(relative ? 'q' : 'Q', x1, y1, x, y);
		},

		/** Continue a quadratic Bézier curve.
  	<p>Control point is the reflection of the previous control point.</p>
  	@param x {number|number[][]} x-coordinate of curve end or x-/y-coordinates of points to draw to.
  	@param [y] {number} y-coordinate of curve end (omitted if <code>x</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		smoothQ: function smoothQ(x, y, relative) {
			relative = $.isArray(x) ? y : relative;
			return this._coords(relative ? 't' : 'T', x, y);
		},

		/** Generate a path command with (a list of) coordinates.
  	@private
  	@param cmd {string} The command for the path element.
  	@param x1 {number} The first x-coordinate.
  	@param y1 {number} The first y-coordinate.
  	@param [x2] {number} The second x-coordinate.
  	@param [y2] {number} The second y-coordinate.
  	@param [x3] {number} The third x-coordinate.
  	@param [y3] {number} The third y-coordinate.
  	@return {SVGPath} This path. */
		_coords: function _coords(cmd, x1, y1, x2, y2, x3, y3) {
			if ($.isArray(x1)) {
				for (var i = 0; i < x1.length; i++) {
					var cs = x1[i];
					this._path += (i === 0 ? cmd : ' ') + cs[0] + ',' + cs[1] + (cs.length < 4 ? '' : ' ' + cs[2] + ',' + cs[3] + (cs.length < 6 ? '' : ' ' + cs[4] + ',' + cs[5]));
				}
			} else {
				this._path += cmd + x1 + ',' + y1 + (x2 == null ? '' : ' ' + x2 + ',' + y2 + (x3 == null ? '' : ' ' + x3 + ',' + y3));
			}
			return this;
		},

		/** Draw an arc to a position.
  	@param rx {number|any[][]} x-radius of arc or x-/y-coordinates and flags for points to draw to.
  	@param [ry] {number} y-radius of arc (omitted if <code>rx</code> is array).
  	@param [xRotate] {number} x-axis rotation (degrees, clockwise) (omitted if <code>rx</code> is array).
  	@param [large] {boolean} <code>true</code> to draw the large part of the arc,
  			<code>false</code> to draw the small part (omitted if <code>rx</code> is array).
  	@param [clockwise] {boolean} <code>true</code> to draw the clockwise arc,
  			<code>false</code> to draw the anti-clockwise arc (omitted if <code>rx</code> is array).
  	@param [x] {number} x-coordinate of arc end (omitted if <code>rx</code> is array).
  	@param [y] {number} y-coordinate of arc end (omitted if <code>rx</code> is array).
  	@param [relative=false] {boolean} <code>true</code> for coordinates relative to the current point,
  			<code>false</code> for coordinates being absolute.
  	@return {SVGPath} This path. */
		arc: function arc(rx, ry, xRotate, large, clockwise, x, y, relative) {
			relative = $.isArray(rx) ? ry : relative;
			this._path += relative ? 'a' : 'A';
			if ($.isArray(rx)) {
				for (var i = 0; i < rx.length; i++) {
					var cs = rx[i];
					this._path += (i === 0 ? '' : ' ') + cs[0] + ',' + cs[1] + ' ' + cs[2] + ' ' + (cs[3] ? '1' : '0') + ',' + (cs[4] ? '1' : '0') + ' ' + cs[5] + ',' + cs[6];
				}
			} else {
				this._path += rx + ',' + ry + ' ' + xRotate + ' ' + (large ? '1' : '0') + ',' + (clockwise ? '1' : '0') + ' ' + x + ',' + y;
			}
			return this;
		},

		/** Close the current path.
  	@return {SVGPath} This path. */
		close: function close() {
			this._path += 'z';
			return this;
		},

		/** Return the string rendering of the specified path.
  	@return {string} The stringified path. */
		path: function path() {
			return this._path;
		}
	});

	SVGPath.prototype.moveTo = SVGPath.prototype.move;
	SVGPath.prototype.lineTo = SVGPath.prototype.line;
	SVGPath.prototype.horizTo = SVGPath.prototype.horiz;
	SVGPath.prototype.vertTo = SVGPath.prototype.vert;
	SVGPath.prototype.curveCTo = SVGPath.prototype.curveC;
	SVGPath.prototype.smoothCTo = SVGPath.prototype.smoothC;
	SVGPath.prototype.curveQTo = SVGPath.prototype.curveQ;
	SVGPath.prototype.smoothQTo = SVGPath.prototype.smoothQ;
	SVGPath.prototype.arcTo = SVGPath.prototype.arc;

	/** Helper to generate an SVG text object.
 	<p>Obtain an instance from the SVGWrapper object.</p>
 	<p>String calls together to generate the text and use its value:</p>
 	@module SVGText
 	@example var text = root.createText();
    root.text(null, x, y, text.string('This is ').
      span('red', {fill: 'red'}).string('!'), {fill: 'blue'}); */
	function SVGText() {
		this._parts = []; // The components of the text object
	}

	$.extend(SVGText.prototype, {
		/** Prepare to create a new text object.
  	@return {SVGText} This text object. */
		reset: function reset() {
			this._parts = [];
			return this;
		},

		/** Add a straight string value.
  	@param value {string} The actual text.
  	@return {SVGText} This text object. */
		string: function string(value) {
			this._parts.push(['text', value]);
			return this;
		},

		/** Add a separate text span that has its own settings.
  	@param value {string} The actual text.
  	@param settings {object} The settings for this text.
  	@return {SVGText} This text object. */
		span: function span(value, settings) {
			this._parts.push(['tspan', value, settings]);
			return this;
		},

		/** Add a reference to a previously defined text string.
  	@param id {string} The ID of the actual text.
  	@param settings {object} The settings for this text.
  	@return {SVGText} This text object. */
		ref: function ref(id, settings) {
			this._parts.push(['tref', id, settings]);
			return this;
		},

		/** Add text drawn along a path.
  	@param id {string} The ID of the path.
  	@param value {string} The actual text.
  	@param settings {object} The settings for this text.
  	@return {SVGText} This text object. */
		path: function path(id, value, settings) {
			this._parts.push(['textpath', value, $.extend({ href: id }, settings || {})]);
			return this;
		}
	});

	/** Attach the SVG functionality to a jQuery selection.
 	@param [command] {string} The command to run.
 	@param [options] {object} The new settings to use for these SVG instances.
 	@return {jQuery} For chaining further calls. */
	$.fn.svg = function (options) {
		var otherArgs = Array.prototype.slice.call(arguments, 1);
		if (typeof options === 'string' && options === 'get') {
			return $.svg['_' + options + 'SVG'].apply($.svg, [this[0]].concat(otherArgs));
		}
		return this.each(function () {
			if (typeof options === 'string') {
				$.svg['_' + options + 'SVG'].apply($.svg, [this].concat(otherArgs));
			} else {
				$.svg._attachSVG(this, options || {});
			}
		});
	};

	// Singleton primary SVG interface
	$.svg = new SVGManager();
})(jQuery);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */

;(function (factory) {
    'use strict';

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function ($) {
    'use strict';

    var Slick = window.Slick || {};

    Slick = function () {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this,
                dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

            _.registerBreakpoints();
            _.init(true);
        }

        return Slick;
    }();

    Slick.prototype.activateADA = function () {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

        var _ = this;

        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }

        _.unload();

        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function (targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }
        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function step(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function complete() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });
            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function () {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };

    Slick.prototype.getNavTarget = function () {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;
    };

    Slick.prototype.asNavFor = function (index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
            asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }
    };

    Slick.prototype.applyTransition = function (slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.autoPlay = function () {

        var _ = this;

        _.autoPlayClear();

        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };

    Slick.prototype.autoPlayClear = function () {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };

    Slick.prototype.autoPlayIterator = function () {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if (!_.paused && !_.interrupted && !_.focussed) {

            if (_.options.infinite === false) {

                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                } else if (_.direction === 0) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }
                }
            }

            _.slideHandler(slideTo);
        }
    };

    Slick.prototype.buildArrows = function () {

        var _ = this;

        if (_.options.arrows === true) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                }
            } else {

                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                    'aria-disabled': 'true',
                    'tabindex': '-1'
                });
            }
        }
    };

    Slick.prototype.buildDots = function () {

        var _ = this,
            i,
            dot;

        if (_.options.dots === true) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');
        }
    };

    Slick.prototype.buildOut = function () {

        var _ = this;

        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }
    };

    Slick.prototype.buildRows = function () {

        var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if (_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };

    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

        var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }
    };

    Slick.prototype.changeSlide = function (event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;

        // If target is a link, prevent default action.
        if ($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }
    };

    Slick.prototype.checkNavigable = function (index) {

        var _ = this,
            navigables,
            prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function () {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.cleanUpSlideEvents = function () {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };

    Slick.prototype.cleanUpRows = function () {

        var _ = this,
            originalSlides;

        if (_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };

    Slick.prototype.clickHandler = function (event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };

    Slick.prototype.destroy = function (refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.$prevArrow.length) {

            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }

        if (_.$nextArrow && _.$nextArrow.length) {

            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }

        if (_.$slides) {

            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
                $(this).attr('style', $(this).data('originalStyling'));
            });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if (!refresh) {
            _.$slider.trigger('destroy', [_]);
        }
    };

    Slick.prototype.disableTransition = function (slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.fadeSlide = function (slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function () {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }
        }
    };

    Slick.prototype.fadeSlideOut = function (slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.focusHandler = function () {

        var _ = this;

        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function () {

                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

        var _ = this;
        return _.currentSlide;
    };

    Slick.prototype.getDotCount = function () {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;
    };

    Slick.prototype.getLeft = function (slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2;
                    }
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;
    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

        var _ = this;

        return _.options[option];
    };

    Slick.prototype.getNavigableIndexes = function () {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;
    };

    Slick.prototype.getSlick = function () {

        return this;
    };

    Slick.prototype.getSlideCount = function () {

        var _ = this,
            slidesTraversed,
            swipedSlide,
            centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };

    Slick.prototype.init = function (creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if (_.options.autoplay) {

            _.paused = false;
            _.autoPlay();
        }
    };

    Slick.prototype.initADA = function () {
        var _ = this,
            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
            return val >= 0 && val < _.slideCount;
        });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                    $(this).attr({
                        'aria-describedby': 'slick-slide-control' + _.instanceUid + slideControlIndex
                    });
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
            _.$slides.eq(i).attr('tabindex', 0);
        }

        _.activateADA();
    };

    Slick.prototype.initArrowEvents = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };

    Slick.prototype.initDotEvents = function () {

        var _ = this;

        if (_.options.dots === true) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true) {

            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initSlideEvents = function () {

        var _ = this;

        if (_.options.pauseOnHover) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initializeEvents = function () {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };

    Slick.prototype.initUI = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();
        }
    };

    Slick.prototype.keyHandler = function (event) {

        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' : 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }
    };

    Slick.prototype.lazyLoad = function () {

        var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                    image.animate({ opacity: 0 }, 100, function () {

                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);

                            if (imageSizes) {
                                image.attr('sizes', imageSizes);
                            }
                        }

                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                    });
                };

                imageToLoad.onerror = function () {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
                };

                imageToLoad.src = imageSource;
            });
        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };

    Slick.prototype.loadSlider = function () {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }
    };

    Slick.prototype.next = Slick.prototype.slickNext = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };

    Slick.prototype.orientationChange = function () {

        var _ = this;

        _.checkResponsive();
        _.setPosition();
    };

    Slick.prototype.pause = Slick.prototype.slickPause = function () {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;
    };

    Slick.prototype.play = Slick.prototype.slickPlay = function () {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };

    Slick.prototype.postSlide = function (index) {

        var _ = this;

        if (!_.unslicked) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if (_.options.autoplay) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };

    Slick.prototype.preventDefault = function (event) {

        event.preventDefault();
    };

    Slick.prototype.progressiveLazyLoad = function (tryCount) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ($imgsToLoad.length) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {

                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);

                    if (imageSizes) {
                        image.attr('sizes', imageSizes);
                    }
                }

                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();
            };

            imageToLoad.onerror = function () {

                if (tryCount < 3) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);
                } else {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                    _.progressiveLazyLoad();
                }
            };

            imageToLoad.src = imageSource;
        } else {

            _.$slider.trigger('allImagesLoaded', [_]);
        }
    };

    Slick.prototype.refresh = function (initializing) {

        var _ = this,
            currentSlide,
            lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if (!initializing) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);
        }
    };

    Slick.prototype.registerBreakpoints = function () {

        var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;

        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }

            _.breakpoints.sort(function (a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };

    Slick.prototype.reinit = function () {

        var _ = this;

        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);
    };

    Slick.prototype.resize = function () {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

        var _ = this;

        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.setCSS = function (position) {

        var _ = this,
            positionProps = {},
            x,
            y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };

    Slick.prototype.setDimensions = function () {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: '0px ' + _.options.centerPadding
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding + ' 0px'
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();

        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };

    Slick.prototype.setFade = function () {

        var _ = this,
            targetLeft;

        _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };

    Slick.prototype.setHeight = function () {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };

    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;

        if ($.type(arguments[0]) === 'object') {

            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {

            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                type = 'responsive';
            } else if (typeof arguments[1] !== 'undefined') {

                type = 'single';
            }
        }

        if (type === 'single') {

            _.options[option] = value;
        } else if (type === 'multiple') {

            $.each(option, function (opt, val) {

                _.options[opt] = val;
            });
        } else if (type === 'responsive') {

            for (item in value) {

                if ($.type(_.options.responsive) !== 'array') {

                    _.options.responsive = [value[item]];
                } else {

                    l = _.options.responsive.length - 1;

                    // loop through the responsive object and splice out duplicates.
                    while (l >= 0) {

                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                            _.options.responsive.splice(l, 1);
                        }

                        l--;
                    }

                    _.options.responsive.push(value[item]);
                }
            }
        }

        if (refresh) {

            _.unload();
            _.reinit();
        }
    };

    Slick.prototype.setPosition = function () {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);
    };

    Slick.prototype.setProps = function () {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };

    Slick.prototype.setSlideClasses = function (index) {

        var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;

        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

        _.$slides.eq(index).addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
                    _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }

                if (index === 0) {

                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                } else if (index === _.slideCount - 1) {

                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
                }
            }

            _.$slides.eq(index).addClass('slick-center');
        } else {

            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
                }
            }
        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function () {

        var _ = this,
            i,
            slideIndex,
            infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                    $(this).attr('id', '');
                });
            }
        }
    };

    Slick.prototype.interrupt = function (toggle) {

        var _ = this;

        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;
    };

    Slick.prototype.selectHandler = function (event) {

        var _ = this;

        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;
        }

        _.slideHandler(index);
    };

    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

        var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if (_.options.asNavFor) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }
        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };

    Slick.prototype.startLoad = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();
        }

        _.$slider.addClass('slick-loading');
    };

    Slick.prototype.swipeDirection = function () {

        var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? 'right' : 'left';
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';
    };

    Slick.prototype.swipeEnd = function (event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            direction = _.swipeDirection();

            switch (direction) {

                case 'left':
                case 'down':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:

            }

            if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);
            }
        } else {

            if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };

    Slick.prototype.swipeHandler = function (event) {

        var _ = this;

        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }
    };

    Slick.prototype.swipeMove = function (event) {

        var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches,
            verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }

        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);
    };

    Slick.prototype.swipeStart = function (event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;
    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.unload = function () {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };

    Slick.prototype.unslick = function (fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();
    };

    Slick.prototype.updateArrows = function () {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };

    Slick.prototype.updateDots = function () {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots.find('li').removeClass('slick-active').end();

            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };

    Slick.prototype.visibility = function () {

        var _ = this;

        if (_.options.autoplay) {

            if (document[_.hidden]) {

                _.interrupted = true;
            } else {

                _.interrupted = false;
            }
        }
    };

    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = window.jQuery;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * jquery.closestchild 0.1.1
 *
 * Author: Andrey Mikhaylov aka lolmaus
 * Email: lolmaus@gmail.com
 *
 */

/* eslint-disable */

;(function ($) {
  $.fn.closestChild = function (selector) {
    var $children, $results;

    $children = this.children();

    if ($children.length === 0) return $();

    $results = $children.filter(selector);

    if ($results.length > 0) return $results;else return $children.closestChild(selector);
  };
})(window.jQuery);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Setup

/* eslint-disable wrap-iife */
/* eslint-disable complexity */
/* eslint-disable max-statements */

/* global jQuery */

(function ($) {

	function setup() {
		var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


		// Create return object
		var object = {
			config: {
				initEvent: 'ready',
				browserClass: '_browser',
				deviceClass: '_device'
			},
			browser: null,
			device: null
		};

		// Overwrite default config
		_extends(object.config, config);

		// Init
		object.init = function () {

			// Initialize everything on the correct event
			$(document).on(object.config.initEvent, function () {

				// Sniff and set browser classes
				object.sniffBrowsers();

				// Trigger setupfinish event
				$(window).trigger('setupfinish');
			});
		};

		// Sniff browsers and add their classes to the body
		object.sniffBrowsers = function () {

			// Get the user agent
			var userAgent = window.navigator.userAgent;

			// If the user agent contains these browser strings, add their browser class to the body and set the browser variable

			// Lynx
			if (userAgent.indexOf('Lynx') !== -1) {
				$('body').addClass(object.config.browserClass + '--lynx');
				object.browser = 'lynx';
			}

			// Edge
			else if (userAgent.indexOf('Edge') !== -1) {
					$('body').addClass(object.config.browserClass + '--edge');
					object.browser = 'edge';
				}

				// Chrome
				else if (userAgent.toLowerCase().indexOf('chrome') !== -1) {
						$('body').addClass(object.config.browserClass + '--chrome');
						object.browser = 'chrome';
					}

					// Safari
					else if (userAgent.toLowerCase().indexOf('safari') !== -1) {
							$('body').addClass(object.config.browserClass + '--safari');
							object.browser = 'safari';
						}

						// IE
						else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident') !== -1) {
								$('body').addClass(object.config.browserClass + '--ie');
								object.browser = 'ie';
							}

							// Gecko
							else if (userAgent.indexOf('Gecko') !== -1) {
									$('body').addClass(object.config.browserClass + '--gecko');
									object.browser = 'gecko';
								}

								// Opera
								else if (userAgent.indexOf('Opera') !== -1) {
										$('body').addClass(object.config.browserClass + '--opera');
										object.browser = 'opera';
									}

									// Netscape (what?)
									else if (userAgent.indexOf('Nav') !== -1 && userAgent.indexOf('Mozilla/4.') !== -1) {
											$('body').addClass(object.config.browserClass + '--ns4');
											object.browser = 'ns4';
										}

										// Unknown
										else {
												$('body').addClass(object.config.browserClass + '--unknown');
											}

			// If the browser is Safari and there is a 'mobile' string in the UA
			if (object.browser === 'safari' && userAgent.toLowerCase().indexOf('mobile') !== -1) {
				$('body').addClass(object.config.deviceClass + '--ios');
				object.device = 'ios';
			}
		};

		return object;
	}

	// Instantiate the setup
	function summonSetup() {
		var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		return Object.create(setup(args));
	}

	// Instantiate and initialize a new setup object
	var theSetup = summonSetup();
	theSetup.init();
})(jQuery);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */

(function ($) {

	$(document).ready(function () {

		function toggleSidebar() {
			$('.c-burger-menu').toggleClass('is-active');
			$('.content-area').toggleClass('is-active');
			$('.plate1').toggleClass('active');
			$('#primary-menu').toggleClass('is-active');
			$('#secondary-menu').toggleClass('is-active');
			$('.c-header__sub .c-footer__social').toggleClass('is-active');
			$('.c-header__branding').toggleClass('is-active');
			$('body').toggleClass('locked-by-menu');
		}

		$('.c-burger-menu').on('click tap', function () {
			toggleSidebar();
		});

		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				toggleSidebar();
			}
		});
	});
})(jQuery);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Slider

/* eslint-disable no-nested-ternary */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-params */
/* eslint-disable function-name-case */

/* global jQuery */

(function ($) {

    // $('.c-testimonial__slider').slick({
    //     dots: false,
    //     nextArrow: '.next',
    //     prevArrow: '.previous',
    //     // autoplay: true,
    //     // autoplaySpeed: 10000,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     cssEase: 'ease-in-out',
    //     responsive: [
    //         {
    //             breakpoint: 767,
    //             settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 1
    //             }
    //         },
    //         {
    //             breakpoint: 639,
    //             settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1
    //             }
    //         }

    //         ]
    // });

    var slickSlide = $('.c-testimonial__slider');

    slickSlide.slick({
        slide: '.c-testimonial__slide',
        dots: false,
        nextArrow: '.next',
        prevArrow: '.previous',
        // autoplay: true,
        // autoplaySpeed: 10000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'ease-in-out',
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 639,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]

    });
})(jQuery);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Slider

/* eslint-disable no-nested-ternary */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-params */
/* eslint-disable function-name-case */

/* global jQuery */

(function ($) {
    $(function () {
        // (Optional) Active an item if it has the class "is-active"	
        $('.c-accordion > .c-accordion-item.is-active').children('.c-accordion-panel').slideDown();

        $('.c-accordion > .c-accordion-item').click(function () {
            // Cancel the siblings
            $(this).siblings('.c-accordion-item').removeClass('is-active').children('.c-accordion-panel').slideUp();
            // Toggle the item
            $(this).toggleClass('is-active').children('.c-accordion-panel').slideToggle('ease-out');
        });
    });
})(jQuery);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Scroll animations

/* eslint-disable wrap-iife */

/* global jQuery */

var _helpers = __webpack_require__(13);

var _helpers2 = _interopRequireDefault(_helpers);

var _throttleDebounce = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {

	function scrollAnimation() {
		var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


		// Create return object
		var object = {
			config: {
				initEvent: 'load',
				scrollAnimationClass: 'js-animation--scroll',
				resolverClass: 'is-resolved',
				scrollListenerThrottle: 125,
				screenBottomOffset: 30
			},
			isSafari: $('body').hasClass('_browser--safari'),
			animatedElements: [],
			windowHeight: window.innerHeight
		};

		// Create object config
		object.config = _extends(object.config, config);

		// Init
		object.init = function () {

			// Query up animated elements based on selector
			object.animatedElements = $('.' + object.config.scrollAnimationClass);

			// If there are any scroll animation elements on the page, initialize
			if (object.animatedElements.length) {

				// Initialize everything on the correct event
				$(window).one(object.config.initEvent, function () {

					// Set whether or not device is Safari
					object.isSafari = $('body').hasClass('_browser--safari');

					// Initially set all element offsets
					object.setElementOffsets();

					// Wire up animation events
					object.events();
				});
			}
		};

		// Events
		object.events = function () {

			// Get jQueryatized window
			var jQueryWindow = $(window);

			// Scroll
			jQueryWindow.on('scroll.scrollAnimationScroll', (0, _throttleDebounce.throttle)(object.config.scrollListenerThrottle, function () {

				// Process scroll
				object.processScroll();

				// If there are no animated elements left, remove the scroll event listener
				if (!object.animatedElements.length) {
					jQueryWindow.off('scroll.scrollAnimationScroll');
				}
			}));

			// Resize
			jQueryWindow.on('resize.scrollAnimationResize dynamicheightguyresize', (0, _throttleDebounce.debounce)(object.config.scrollListenerThrottle, function () {

				// Reset offsets of elements
				object.setElementOffsets();

				// Reset windowHeight
				object.windowHeight = window.innerHeight;

				// Process as if scrolled
				object.processScroll();

				// If there are no animated elements left, remove the resize event listener
				if (!object.animatedElements.length) {
					jQueryWindow.off('resize.scrollAnimationResize');
				}
			}));

			// Process scroll first time
			object.processScroll();
		};

		// Set offsets
		object.setElementOffsets = function () {

			// Loop through animated elements and set offsets
			for (var i = 0; i < object.animatedElements.length; i++) {

				// Reference element
				var element = object.animatedElements[i];

				// Get jQueryatized element
				var jQueryElement = $(element);

				// Set up offsets array
				if (!element.offsetForScroll) {
					element.offsetForScroll = {};
				}

				// Set offsets
				element.offsetForScroll.top = jQueryElement.offset().top;
				element.offsetForScroll.bottom = element.offsetForScroll.top + element.getBoundingClientRect().height;
			}
		};

		// Process the scrolls
		object.processScroll = function () {

			// Get scrollTop and scrollBottom
			var scrollTop = window.pageYOffset;
			var scrollBottom = scrollTop + object.windowHeight;

			// Loop through animated elements and resolve them

			var _loop = function _loop(i) {

				// Get element
				var element = object.animatedElements[i];

				// Resolve animation on element
				window.setTimeout(function () {
					object.resolveAnimation(element, scrollTop, scrollBottom);
				}, 0);
			};

			for (var i = 0; i < object.animatedElements.length; i++) {
				_loop(i);
			}
		};

		// Resolve animations
		object.resolveAnimation = function (element, scrollTop, scrollBottom) {

			// If the element is in the viewport, resolve the animation
			if (_helpers2.default.isInViewport(element.offsetForScroll.top, element.offsetForScroll.bottom, scrollTop, scrollBottom, object.config.screenBottomOffset)) {

				// jQueryatize element
				var jQueryElement = $(element);

				// If element is an SVG, add the class manually
				if (jQueryElement.is('svg, line, circle, path')) {

					// Get current class
					var currentClass = jQueryElement.attr('class');

					// Add the class
					jQueryElement.attr('class', currentClass + ' ' + object.config.resolverClass);
				}

				// Otherwise, just add resolver class
				else {
						jQueryElement.addClass(object.config.resolverClass);
					}

				// If the browser is Safari or whatever else makes it suck, make it not suck
				object.makeSafariNotSuck(jQueryElement);

				// Remove element from animated element array
				object.animatedElements = object.animatedElements.not(element);
			}
		};

		// Force animation to work on Safari
		object.makeSafariNotSuck = function (jQueryElement) {

			// Get the animation name property
			var animationName = jQueryElement.css('animation-name');

			// Determine what to change the animation name to temporarily
			var tempAnimationName = object.isSafari ? 'none' : '';

			// Reset that animation name
			jQueryElement.css('animation-name', tempAnimationName);

			// Immediately bring it back
			window.setTimeout(function () {
				jQueryElement.css('animation-name', animationName);
			}, 0);
		};

		return object;
	}

	// Instantiate the scroll animations
	function summonScrollAnimation() {
		var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		return Object.create(scrollAnimation(args));
	}

	// Instantiate and initialize a new scrollAnimations object
	var theScrollAnimation = summonScrollAnimation();
	theScrollAnimation.init();
})(jQuery);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Helpers

/* eslint-disable max-params */
/* exported helpers */

var helpers = {

	// Determine if element is within viewport
	isInViewport: function isInViewport(elementTop, elementBottom) {
		var scrollTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var scrollBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


		// If scrollTop and scrollBottom are not defined, get them from the window object
		if (scrollTop === null || scrollBottom === null) {

			// Set scroll constants
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			scrollBottom = scrollTop + window.innerHeight;
		}

		// Return whether or not the element is in the viewport
		return (
			// Top is between top and bottom of viewport
			elementTop >= scrollTop + offset && elementTop <= scrollBottom - offset

			// Bottom is between top and bottom of viewport
			|| elementBottom >= scrollTop + offset && elementBottom <= scrollBottom - offset

			// Top is above viewport while bottom is beneath (component is larger than viewport)
			|| elementTop <= scrollTop && elementBottom >= scrollBottom
		);
	},

	// Clamp a number
	clamp: function clamp(number, min, max) {
		return Math.min(Math.max(number, min), max);
	},

	// Wraparound numbers
	wrapAround: function wrapAround(number, min, max) {

		// Parse the number
		number = Number(number);

		// If the number is less than the min, return the max
		if (number < min) {
			return max;
		}

		// Otherwise, if the number is greater than the max, return the min
		else if (number > max) {
				return min;
			}

		// Otherwise, return the number
		return number;
	}
};

exports.default = helpers;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _simpleParallaxJs = __webpack_require__(1);

var _simpleParallaxJs2 = _interopRequireDefault(_simpleParallaxJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {

  var image = document.getElementsByClassName('js-parallax--scroll');
  new _simpleParallaxJs2.default(image, {
    scale: 1.1
  });
})(jQuery); // Scroll animations

/* eslint-disable wrap-iife */

/* global jQuery */

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
/* eslint-disable no-invalid-this */

(function ($) {

	$(document).on('nfFormReady', function () {
		console.log('Form is ready');

		$(document).on('focus', '#nf-field-1-wrap', function () {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-1-wrap', function () {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-1-wrap', function () {
			if ($('input.ninja-forms-field').val().length > 0) {
				$(this).addClass('is-active');
			} else {
				$(this).removeClass('is-active');
			}
		});

		$(document).on('focus', '#nf-field-2-wrap', function () {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-2-wrap', function () {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-2-wrap', function () {
			if ($('#nf-field-2').val().length > 0) {
				$(this).addClass('is-active');
			} else {
				$(this).removeClass('is-active');
			}
		});

		$(document).on('focus', '#nf-field-3-wrap', function () {
			$(this).addClass('is-active');
		});
		$(document).on('focusout', '#nf-field-3-wrap', function () {
			$(this).removeClass('is-active');
		});
		$(document).on('blur', '#nf-field-3-wrap', function () {
			if ($('textarea.ninja-forms-field').val().length > 0) {
				$(this).addClass('is-active');
			} else {
				$(this).removeClass('is-active');
			}
		});

		// $(document).on('focus', '#nf-field-2-wrap', function() {
		// 	$(this).addClass('is-active');
		// });
		// $(document).on('focusout', '#nf-field-2-wrap', function() {
		// 	$(this).removeClass('is-active');
		// });
		// $(document).on('blur', '#nf-field-2-wrap', function() {
		// 	if ($('.ninja-forms-field').val().length > 0) {
		// 		$(this).addClass('is-active');
		// 	}
		// 	else {
		// 		$(this).removeClass('is-active');
		// 	}
		// });

		// $(document).on('focus', '#nf-field-3-wrap', function() {
		// 	$(this).addClass('is-active');
		// });
		// $(document).on('focusout', '#nf-field-3-wrap', function() {
		// 	$(this).removeClass('is-active');
		// });
		// $('.ninja-forms-field').on('blur', function() {
		// 	if ($('.ninja-forms-field').val().length > 0) {
		// 		$(this).addClass('is-active');
		// 	}
		// 	else {
		// 		$(this).removeClass('is-active');
		// 	}
		// });

	});
})(jQuery);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/js/main.js